module.exports = __webpack_public_path__ + "img/loan_check_list.099b42ab.png";